<template>
    <div class="page">
      <el-page-header @back="onBack" title="" content="學習表現-冒險模式"></el-page-header>
      <div class="page-content">
          <el-form :model="from" label-position="left" label-width="80px"  :rules="rules" ref="ruleForm" class="demo-form-inline">
            <el-form-item label="分校" prop="branchSchoolId">
              <el-select v-model="from.branchSchoolId" placeholder="全部">
                <el-option
                  v-for="item in sortBranchesList"
                  :key="item.id"
                  :label="item.abbreviation"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年級" prop="gradeId">
              <el-select v-model="from.gradeId" placeholder="全部">
                <el-option
                  v-for="item in allGrades"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-button type="info" @click="onExport">導出</el-button>
            </el-form-item>
          </el-form>
      </div>
    </div>
  </template>
  
  <script>
  import {downloadFile} from '@/utils/is-rules'
  import { getPractiseReport} from "@/api/report";
  import { getBranchSchools } from "@/api/setting";
  import { getGrades } from '@/api/grade'
  export default {
    data() {
      return {
        tableData: [],
        allGrades: [],
        from: {
          branchSchoolId: null,
          gradeId: null,
        },
        rules:{
          branchSchoolId: [
            { required: true, message: '請選擇日期', trigger: 'change' }
          ],
          gradeId:[{ required: true, message: '請選擇年級', trigger: 'change' }],
        }
      };
    },
    created() {
      this.getAllGrades()
      this.getBranchSchools()
    },
    methods: {
      getAllGrades(){
          let formLabelAlign = {
            _page: 0,
            _limit: 0,
          }
         getGrades(formLabelAlign).then((v)=>{
            this.allGrades = v.data
         })
      },
      getBranchSchools() {
        getBranchSchools().then((v) => {
          this.tableData = v.data;
        });
      },
      onExport(){
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.getPractiseReport()
          }
        })
      },
      getPractiseReport(){
        let formLabelAlign = {
              gradeId: this.from.gradeId,
              branchSchoolId: this.from.branchSchoolId,
            }
        getPractiseReport(formLabelAlign).then((v)=>{
          downloadFile(v.data,'學習表現-冒險模式.xlsx')
        })
      }
    },
  };
  </script>
          
  <style lang="scss" scoped>
  .el-page-header{
    margin-bottom: 20px;
  }
  .page-title{
    margin-bottom: 20px;
  }
  .page-content{
    background-color: #fff;
    padding: 20px;
  }
  </style>